<!--The content below is only a placeholder and can be replaced.-->
<div class="jumbotron">
  <div class="container">
    <ngb-alert type="success" [dismissible]="false">
        Welcome to {{title}}!
    </ngb-alert>
  </div>
</div>

<stumpy-tracker></stumpy-tracker>

<div class="container">
  <div class="row">
    <div class="col-xs-12">
      <footer>
        <p>
          Source code for this tracker is available on <a href="https://github.com/wolfman2000/stumpy"><i class="fa fa-git" title="Github"></i></a>.
          Please support the <a href="https://alttpr.com/">LttP Randomizer</a>.
        </p>
        <p>
          Shout-outs to <a href="https://www.twitch.tv/crossproduct">Crossproduct</a>,
          <a href="https://alttp.orphis.net">Orphis</a>, and
          <a href="https://lttp-tracker.firebaseapp.com/">Pickfifteen</a> for their
          prior tracker work and logic. This could not have been built without their assistance.
        </p>
      </footer>
    </div>
  </div>
</div>
